import {
  POST_UPSERT_FAIL,
  POST_UPSERT_REQUEST,
  POST_UPSERT_RESET,
  POST_UPSERT_SUCCESS,
  POST_CREATE_REVIEW_FAIL,
  POST_CREATE_REVIEW_REQUEST,
  POST_CREATE_REVIEW_RESET,
  POST_CREATE_REVIEW_SUCCESS,
  POST_DELETE_FAIL,
  POST_DELETE_REQUEST,
  POST_DELETE_SUCCESS,
  POST_DELETE_RESET,
  POST_EDIT_FAIL,
  POST_EDIT_REQUEST,
  POST_EDIT_RESET,
  POST_EDIT_SUCCESS,
  POST_DETAILS_FAIL,
  POST_DETAILS_REQUEST,
  POST_DETAILS_SUCCESS,
  POST_LIST_FAIL,
  POST_LIST_REQUEST,
  POST_LIST_SUCCESS,
  POST_BY_BUSINESS_LIST_REQUEST,
  POST_BY_BUSINESS_LIST_SUCCESS,
  POST_BY_BUSINESS_LIST_FAIL,
  POST_LIKE_FAIL,
  POST_LIKE_REQUEST,
  POST_LIKE_RESET,
  POST_LIKE_SUCCESS,
  POST_REVIEW_LIST_REQUEST,
  POST_REVIEW_LIST_SUCCESS,
  POST_REVIEW_LIST_FAIL,
  POST_SHARE_REQUEST,
  POST_SHARE_SUCCESS,
  POST_SHARE_FAIL,
  POST_SHARE_RESET,
  POST_ANALYTICS_REQUEST,
  POST_ANALYTICS_SUCCESS,
  POST_ANALYTICS_FAIL,
  POST_VIEW_FAIL,
  POST_VIEW_REQUEST,
  POST_VIEW_RESET,
  POST_VIEW_SUCCESS,
} from "../Constants/PostConstants";

// POST LIST
export const postListReducer = (
  state = {
    loading: false,
    recordItems: [],
    page: 1,
    pages: 1,
    hasMore: true,
  },
  action
) => {
  switch (action.type) {
    case POST_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case POST_LIST_SUCCESS: {
      const { items, page, pages, hasMore } = action.payload;

      const merged =
        page === 1
          ? items
          : [
              ...state.recordItems,
              ...items.filter(
                (item) =>
                  !state.recordItems.some(
                    (existing) => existing.postId === item.postId
                  )
              ),
            ];

      return {
        loading: false,
        recordItems: merged,
        page,
        pages,
        hasMore,
      };
    }

    case POST_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// POST LIST
export const postByBusinessListReducer = (
  state = { recordItems: [] },
  action
) => {
  switch (action.type) {
    case POST_BY_BUSINESS_LIST_REQUEST:
      return { loading: true, recordItems: [] }; //, nextStartKey: null };
    case POST_BY_BUSINESS_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        //pages: action.payload.pages,
        //nextStartKey: action.payload.nextStartKey,
        recordItems: action.payload.recordItems,
      };
    case POST_BY_BUSINESS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// SINGLE POST
export const postDetailsReducer = (
  state = { post: { reviews: [] } },
  action
) => {
  switch (action.type) {
    case POST_DETAILS_REQUEST:
      return { ...state, loading: true };
    case POST_DETAILS_SUCCESS:
      return { loading: false, post: action.payload.items };
    case POST_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// POST UPSERT
export const postUpsertReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_UPSERT_REQUEST:
      return { loading: true };
    case POST_UPSERT_SUCCESS:
      return { loading: false, success: true, recordItem: action.payload };
    case POST_UPSERT_FAIL:
      return { loading: false, error: action.payload };
    case POST_UPSERT_RESET:
      return {};
    default:
      return state;
  }
};

export const postDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_DELETE_REQUEST:
      return { loading: true };
    case POST_DELETE_SUCCESS:
      return { loading: false, success: true };
    case POST_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case POST_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const postEditReducer = (state = { recordItem: undefined }, action) => {
  switch (action.type) {
    case POST_EDIT_REQUEST:
      return { ...state, loading: true };
    case POST_EDIT_SUCCESS:
      return { loading: false, recordItem: action.payload.item };
    case POST_EDIT_FAIL:
      return { loading: false, error: action.payload };
    case POST_EDIT_RESET:
      return {};
    default:
      return state;
  }
};

// POST LIKE/UNLIKE
export const postLikeReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_LIKE_REQUEST:
      return { loading: true };
    case POST_LIKE_SUCCESS:
      return { loading: false, success: true, post: action.payload };
    case POST_LIKE_FAIL:
      return { loading: false, error: action.payload };
    case POST_LIKE_RESET:
      return {};
    default:
      return state;
  }
};

// POST VIEW
export const postViewReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_VIEW_REQUEST:
      return { loading: true };
    case POST_VIEW_SUCCESS:
      return { loading: false, success: true, recordItem: action.payload.item };
    case POST_VIEW_FAIL:
      return { loading: false, error: action.payload };
    case POST_VIEW_RESET:
      return {};
    default:
      return state;
  }
};

// REVIEW LIST
export const postReviewListReducer = (state = { reviews: [] }, action) => {
  switch (action.type) {
    case POST_REVIEW_LIST_REQUEST:
      return { loading: true, reviews: [] };
    case POST_REVIEW_LIST_SUCCESS:
      return { loading: false, reviews: action.payload };
    case POST_REVIEW_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// POST REVIEW CREATE
export const postCreateReviewReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_CREATE_REVIEW_REQUEST:
      return { loading: true };

    case POST_CREATE_REVIEW_SUCCESS:
      return {
        loading: false,
        success: true,
        post: action.payload, // ✅ store updated post
      };

    case POST_CREATE_REVIEW_FAIL:
      return { loading: false, error: action.payload };

    case POST_CREATE_REVIEW_RESET:
      return {};

    default:
      return state;
  }
};

// SHARE POST
export const postShareReducer = (state = {}, action) => {
  switch (action.type) {
    case POST_SHARE_REQUEST:
      return { loading: true };
    case POST_SHARE_SUCCESS:
      return { loading: false, success: true, post: action.payload };
    case POST_SHARE_FAIL:
      return { loading: false, error: action.payload };
    case POST_SHARE_RESET:
      return {};
    default:
      return state;
  }
};

export const postAnalyticsReducer = (state = { analytics: {} }, action) => {
  switch (action.type) {
    case POST_ANALYTICS_REQUEST:
      return { loading: true, analytics: {} };
    case POST_ANALYTICS_SUCCESS:
      return { loading: false, analytics: action.payload };
    case POST_ANALYTICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
